import { signal, Signal } from "@angular/core";

export abstract class AbstractNavItem {  
}

export abstract class TypedNavItem<T> extends AbstractNavItem {
  public items: Signal<T[]> = signal([]);
}